// @flow
import TeamStaffs from 'components/team/TeamStaffs';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/team/TeamStaffs';
import { fetchTeamList } from 'actions/teamlistActions';
import { fetchPageList } from 'actions/pageActions';
import { fetchStaffsTeam, initialFetchStaffsTeam, resetStaff } from 'actions/staffActions';
import { searchStaff } from 'actions/filterOptionsActions';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageListState.title,
    excerpt: state.pageListState.excerpt,
    featured_media: state.pageListState.featured_media,
    meta_title: state.pageListState.meta_title,
    meta_description: state.pageListState.meta_description,
    sidebar_content: state.pageListState.sidebar_content,
    staffsFetchStatus: state.staffState.status,
    staffs: state.staffState.staffs,
    status: state.pageListState.status,
    searchedStaff: state.filterOptionsState.searchedStaff,
    defaultSeason: state.filterOptionsState.defaultSeason,
    seasons: state.seasonsState.seasons,
    teamlist: state.teamlistState.teamlist,
    redirect_competitions: state.pageListState.redirect_competitions,
    redirect_resultats: state.pageListState.redirect_resultats
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    fetchStaffsTeam: (filters: Object) => dispatch(fetchStaffsTeam(filters)),
    searchStaff: (searchedStaff: string) => dispatch(searchStaff(searchedStaff)),
    initialFetchStaffsTeam: (filters: Object) => dispatch(initialFetchStaffsTeam(filters)),
    fetchTeamList: () => dispatch(fetchTeamList()),
    resetStaff: () => dispatch(resetStaff())
  })
)(TeamStaffs);
